export default __webpack_public_path__ + "static/media/tournament_icon.befd3eb9.svg";